import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from '../reducers';

let createStoreWithMiddleware;

if (process.env.NODE_ENV === 'production') {
  createStoreWithMiddleware = applyMiddleware(thunk)(createStore);
} else {
  createStoreWithMiddleware = applyMiddleware(
    thunk,
    createLogger({ collapsed: true }),
  )(createStore);
}

export default function configureStore(initialState = {}) {
  return createStoreWithMiddleware(rootReducer, initialState);
}



// WEBPACK FOOTER //
// ./src/store/configure-store.js